import './hero.css';
export default function Hero() {
  return (
    <div className='heroWrapper' id='top'>
      <div className='aligner'>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
        </div>
        <div className='heroText'>
          <h2 style={{ fontFamily: 'Mono' }}>hey, i'm </h2>
          <div className='nameWrapper'>
            <h1
              className='name'
              style={{ fontFamily: 'Mono' }}
            >
              miguel!
            </h1>
          </div>
          <h2>full-stack web developer</h2>
        </div>
        <div className='nav'>
          <a className='navitem' href='#skills'>
            skills
          </a>
          <a className='navitem' href='#contact'>
            contact
          </a>
          <a className='navitem' href='#projects'>
            projects
          </a>
          <a className='navitem' href='#links'>
            links
          </a>
        </div>
      </div>
    </div>
  );
}
